/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Deutsch12Inputs */

const en__field_enum_icsrm_deutsch12 = /** @type {(inputs: _Field_Enum_Icsrm_Deutsch12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de__field_enum_icsrm_deutsch12 = /** @type {(inputs: _Field_Enum_Icsrm_Deutsch12Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {_Field_Enum_Icsrm_Deutsch12Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_deutsch12 = /** @type {((inputs?: _Field_Enum_Icsrm_Deutsch12Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Deutsch12Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_deutsch12(inputs)
	return de__field_enum_icsrm_deutsch12(inputs)
});
export { _field_enum_icsrm_deutsch12 as "_field_enum_ICSRM_DEUTSCH" }